<script setup>
import { onUnmounted, watch } from 'vue';

// eslint-disable-next-line no-undef
const props = defineProps({
    modelValue: Boolean,
});

// eslint-disable-next-line no-undef
const emit = defineEmits(['update:modelValue']);

const toggleBodyScroll = (disable) => {
    if (disable) {
        document.body.classList.add('signup-component__modal--open');
    } else {
        document.body.classList.remove('signup-component__modal--open');
    }
};

watch(() => props.modelValue, (newVal) => {
    toggleBodyScroll(newVal);
}, { immediate: true });

onUnmounted(() => {
    document.body.classList.remove('signup-component__modal--open');
});
</script>

<template>
    <teleport to="body">
        <transition name="fade">
            <div
                v-if="props.modelValue"
                class="tw-fixed tw-inset-0 tw-z-50 tw-flex tw-items-center tw-justify-center
                 tw-bg-black/50 tw-font-raleway"
                @keydown.esc="emit('update:modelValue', false)"
            >
                <div
                    class="tw-bg-white tw-shadow-xl tw-w-auto tw-p-6 tw-relative tw-rounded"
                    @click.stop
                >
                    <slot name="title" />

                    <slot />

                    <slot name="footer" />
                </div>
            </div>
        </transition>
    </teleport>
</template>

<style scoped>
.fade-enter-active,
.fade-leave-active {
    transition: opacity 0.2s ease;
}

.fade-enter-from,
.fade-leave-to {
    opacity: 0;
}

/* Global style to prevent scrolling when modal is open */
:global(body.signup-component__modal--open) {
    @apply tw-overflow-hidden;
}
</style>
